'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdOpenWith = function MdOpenWith(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.4 25v5h5l-8.4 8.4-8.4-8.4h5v-5h6.8z m15-5l-8.4 8.4v-5h-5v-6.8h5v-5z m-23.4-3.4v6.8h-5v5l-8.4-8.4 8.4-8.4v5h5z m1.6-1.6v-5h-5l8.4-8.4 8.4 8.4h-5v5h-6.8z' })
        )
    );
};

exports.default = MdOpenWith;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/open-with.js
// module id = 3605
// module chunks = 168707334958949